import React from 'react';

import ActivityTeaser from './Teaser';
import ActivityOverlay from './Overlay';

import type { ImmutableTaxonomyActivity } from '../../../types/taxonomy';

export interface ActivityProps {
  entity: ImmutableTaxonomyActivity,
  viewMode: 'default' | 'overlay' | 'teaser',
}

const Activity: React.FC<ActivityProps> = (props) => {
  const { viewMode } = props;

  if (viewMode === 'teaser') {
    return <ActivityTeaser {...props} />;
  }
  if (viewMode === 'overlay') {
    return <ActivityOverlay {...props} />;
  }
  return null;
};

export default Activity;
